// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file assessment/v1/assessment_score.proto (package assessment.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file assessment/v1/assessment_score.proto.
 */
export const file_assessment_v1_assessment_score: GenFile = /*@__PURE__*/
  fileDesc("CiRhc3Nlc3NtZW50L3YxL2Fzc2Vzc21lbnRfc2NvcmUucHJvdG8SDWFzc2Vzc21lbnQudjEquwEKD0Fzc2Vzc21lbnRTY29yZRIgChxBU1NFU1NNRU5UX1NDT1JFX1VOU1BFQ0lGSUVEEAASHwobQVNTRVNTTUVOVF9TQ09SRV9BQ0NFUFRBQkxFEAESHwobQVNTRVNTTUVOVF9TQ09SRV9DT05DRVJOSU5HEAISIQodQVNTRVNTTUVOVF9TQ09SRV9VTkFDQ0VQVEFCTEUQAxIhCh1BU1NFU1NNRU5UX1NDT1JFX05PVF9BU1NFU1NFRBAEQsMBChFjb20uYXNzZXNzbWVudC52MUIUQXNzZXNzbWVudFNjb3JlUHJvdG9QAVpDZ2l0aHViLmNvbS9sZW1hLmFpL2xlbW1hdGEvYXBpL3Byb3RvL2dlbi9hc3Nlc3NtZW50L3YxO2Fzc2Vzc21lbnR2MaICA0FYWKoCDUFzc2Vzc21lbnQuVjHKAg1Bc3Nlc3NtZW50XFYx4gIZQXNzZXNzbWVudFxWMVxHUEJNZXRhZGF0YeoCDkFzc2Vzc21lbnQ6OlYxYgZwcm90bzM");

/**
 * @generated from enum assessment.v1.AssessmentScore
 */
export enum AssessmentScore {
  /**
   * @generated from enum value: ASSESSMENT_SCORE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSESSMENT_SCORE_ACCEPTABLE = 1;
   */
  ACCEPTABLE = 1,

  /**
   * @generated from enum value: ASSESSMENT_SCORE_CONCERNING = 2;
   */
  CONCERNING = 2,

  /**
   * @generated from enum value: ASSESSMENT_SCORE_UNACCEPTABLE = 3;
   */
  UNACCEPTABLE = 3,

  /**
   * @generated from enum value: ASSESSMENT_SCORE_NOT_ASSESSED = 4;
   */
  NOT_ASSESSED = 4,
}

/**
 * Describes the enum assessment.v1.AssessmentScore.
 */
export const AssessmentScoreSchema: GenEnum<AssessmentScore> = /*@__PURE__*/
  enumDesc(file_assessment_v1_assessment_score, 0);

